export function getSelectApiMetaData(response) {
  return response?.data?.pagination
}

export function getSelectArrowButtonTooltipKey(
  isOpen,
  closeText = 'Select.CloseTooltipKey',
  openText = 'Select.OpenTooltipKey'
) {
  return isOpen ? closeText : openText
}

export function getLocalSearchOptions(value, items, key = 'label') {
  if (!value) {
    return items
  }

  return items.filter(i => i[key].includes(value))
}

export function checkShowCustomSelectListDropdown() {
  return true
}

export function checkNeedLoadDataOnCustomSelectOpen({
  debouncedSearch,
  minSearchString,
  shouldLoadOnEmptyString,
}) {
  return (
    debouncedSearch?.length >= minSearchString ||
    (shouldLoadOnEmptyString && !debouncedSearch)
  )
}
